import React from "react";
import { Input} from "@jdcfe/legao";
import './style.scss';


export default function BindContactInput(props)  {
const { appKey } = props;

  return (
   <div className="bind_contact_input">
    <div className="bin_warning">
       <i className="icon_warning"></i>
       绑定前请确认已完成合同签约，如有疑问请联系相关运营人员
    </div>
    <div className="bind_tips">
       您正在操作<span className="key">AppKey: {appKey}</span> 的合同数据绑定操作。绑定后，您的应用将获得合同对应的接口及数据权限，同一个合同号仅支持绑定一个应用。
    </div>
    <div className="input_item">
       <span className="title">ClientId</span>
       <Input className="contractNumber" placeholder="请输入运营人员提供的ClientId" hasClear />
       <span className="errMsg">clientId不存在，请重新输入</span>
    </div>
    <div className="input_item">
       <span className="title">采购账号</span>
       <Input className="bizUserPin" placeholder="请输入运营人员提供的采购账号（Bpin）" hasClear />
       <span className="errMsg">请输入采购账号名称</span>
    </div>
    <div className="input_item">
       <span className="title">采购密码</span>
       <Input className="bizUserPwdMd5" placeholder="请输入运营人员提供的采购账号（Bpin）密码" hasClear type="password" />
       <span className="errMsg">采购密码错误，请重新输入</span>
    </div>
   </div>
  )
}